

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { mergeReducers } from '../functions';

import { FeatureName } from './feature';
import { reducers } from './reducers';
import { effects } from './effects';



@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, mergeReducers(...reducers)),
		EffectsModule.forFeature(effects)
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class UserPrefsStoreModule { }
